module.exports = __webpack_public_path__ + "img/demo-marketing-consultant.62903dc2.jpg";